import ProductModel from "./ProductModel";

const MODEL_ORIGINAL_URL =
  "https://customer-assets.emergentagent.com/job_peptide-protection/artifacts/6nzhgfhw_L_medicine%20box.glb";

const MODEL_XL_URL =
  "https://customer-assets.emergentagent.com/job_peptide-protection/artifacts/wy5brjoi_XL_medical%20box.glb";

function SizeCard({ image, model, name, tag, capacity, spec, badge, testId }) {
  return (
    <div
      data-testid={testId}
      className="reveal rounded-3xl overflow-hidden border border-[#8A97A8]/25 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_30px_70px_-30px_rgba(2,47,107,0.3)]"
    >
      <div className="aspect-[4/3] bg-gradient-to-b from-slate-50 to-slate-100 relative">
        {model ? (
          <ProductModel src={model} alt={name} background="light" />
        ) : (
          <img
            src={image}
            alt={name}
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
        )}
        {badge && (
          <span className="absolute top-4 left-4 z-10 overline text-[9.5px] px-2.5 py-1 rounded-full bg-signature-gradient text-white">
            {badge}
          </span>
        )}
      </div>
      <div className="p-8">
        <h3 className="font-display font-bold text-navy-deep text-xl">{name}</h3>
        <div className="overline text-cool-grey text-[10px] mt-2">{tag}</div>
        <dl className="mt-6 grid grid-cols-2 gap-4 text-sm">
          <div>
            <dt className="overline text-cool-grey text-[9.5px]">Capacity</dt>
            <dd className="font-mono-data text-navy-deep mt-1 text-[13px]">
              {capacity}
            </dd>
          </div>
          <div>
            <dt className="overline text-cool-grey text-[9.5px]">Battery / Weight</dt>
            <dd className="font-mono-data text-navy-deep mt-1 text-[13px]">
              {spec}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
}

export default function SizeGuide() {
  return (
    <section
      id="products"
      data-testid="size-guide"
      className="scroll-mt-24 md:scroll-mt-28 lg:scroll-mt-32 py-14 sm:py-20 bg-cool-white"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="overline text-cyan-brand">Size guide</div>
          <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-[54px] font-bold text-navy-deep tracking-tight leading-[1.05]">
            Which size is right for me?
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 lg:gap-6">
          <SizeCard
            testId="size-original"
            model={MODEL_ORIGINAL_URL}
            name="CryoVault Original"
            tag="Everyday · Travel-ready"
            capacity="8–12 vials · 1–3 insulin pens"
            spec="Up to 10h · 0.7 kg"
          />
          <SizeCard
            testId="size-xl"
            model={MODEL_XL_URL}
            name="CryoVault XL"
            tag="Home & large collections"
            capacity="20–25 vials · 4–6 insulin pens"
            spec="Up to 14h · 1.2 kg"
            badge="New"
          />
        </div>

        <div className="mt-10 rounded-3xl border border-teal-brand/30 bg-teal-brand/5 p-7 reveal">
          <div className="overline text-teal-brand">Not sure which to choose?</div>
          <p className="mt-3 text-navy-deep text-[15px] leading-relaxed max-w-3xl">
            Travelling weekly or carrying a few pens? Go{" "}
            <span className="font-semibold">Original</span>. Managing a monthly
            supply at home or juggling multiple vial types?{" "}
            <span className="font-semibold">XL is worth it.</span>
          </p>
        </div>
      </div>
    </section>
  );
}
